import { history } from 'instantsearch.js/es/lib/routers';
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings';

export function setupRouting(indexName) {
    return {
        router: history(),
        stateMapping: {
            stateToRoute(uiState) {
                const mapper = singleIndex(indexName);
                const route = mapper.stateToRoute(uiState);
                if (route.query) {
                    route.s = route.query;
                    delete route.query;
                }
                return route;
            },
            routeToState(routeState) {
                const mapper = singleIndex(indexName);
                const params = new URLSearchParams(window.location.search);
                const s = params.get('s') || routeState.s;
                if (s) {
                    routeState.query = s;
                }
                return mapper.routeToState(routeState);
            },
        },
    };
}
